export enum ESectionLesson {
  DESCRIPTION = "description",
  DOCUMENT = "document",
}
